import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check if user has already accepted cookies
    try {
      if (localStorage.getItem('cookieConsentAccepted') !== 'true') {
        // Show the banner if consent hasn't been given
        this.element.classList.remove('hidden')
      }
    } catch (e) {
      // If localStorage is not available, show the banner
      console.error('Error accessing localStorage:', e)
      this.element.classList.remove('hidden')
    }
  }

  accept() {
    try {
      // Store consent in localStorage
      localStorage.setItem('cookieConsentAccepted', 'true')
      
      // Add transition class for smooth animation
      this.element.classList.add('transform', 'transition-transform', 'duration-300', 'translate-y-full')
      
      // Hide the banner after animation completes
      setTimeout(() => {
        this.element.classList.add('hidden')
      }, 300)
    } catch (e) {
      // If localStorage is not available, just hide the banner
      console.error('Error saving consent:', e)
      this.element.classList.add('hidden')
    }
  }
}
